import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <div className='mb-8 animate-fade-in'>
      <div className='flex items-center justify-between mb-2'>
        <div>
          <h1 className='text-3xl font-extrabold text-slate-900'>{title}</h1>
          {subtitle && <p className='text-slate-500 mt-1'>{subtitle}</p>}
        </div>
        {actions && <div className='flex items-center gap-3'>{actions}</div>}
      </div>
    </div>
  );
}
